import './InfoButton.scss';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import * as PropTypes from 'prop-types';

export interface IInfoButtonProps {
    message: string;
}

export interface IInfoButtonState {
    isCalloutVisible: boolean;
}

export class InfoButton extends React.Component<IInfoButtonProps, IInfoButtonState> {
    private _infoButton: HTMLElement;

    static contextTypes = {
        strings: PropTypes.object.isRequired
    };

    constructor(props: IInfoButtonProps, context: any) {
        super(props);

        this.state = {
            isCalloutVisible: false
        };
    }

    public render() {
        const props = this.props;
        const state = this.state;

        return (
            <div>
                <div
                    className='od-InfoButton-button'
                    onClick={ this._onShowCallout }
                    ref={ this._onInfoButton }
                >
                    <Icon
                        iconName='Info'
                        className='od-InfoButton-infoIcon'
                        onMouseOver={ this._onShowCallout }
                        onMouseLeave={ this._onDismissCallout }
                    />
                </div>
                { state.isCalloutVisible && (
                    <Callout
                        directionalHint={ DirectionalHint.topCenter }
                        gapSpace={ 2 }
                        onDismiss={ this._onDismissCallout }
                        target={ this._infoButton }
                        setInitialFocus={ true }
                    >
                        <div className='od-InfoButton-content'>
                            <span className='od-InfoButton-message'>{ props.message }</span>
                        </div>
                    </Callout>
                ) }
            </div>
        );
    }

    @autobind
    private _onShowCallout() {
        this.setState({
            ...this.state,
            isCalloutVisible: true
        });
    }

    @autobind
    private _onDismissCallout() {
        this.setState({
            ...this.state,
            isCalloutVisible: false
        });
    }

    @autobind
    private _onInfoButton(element: HTMLElement): any {
        this._infoButton = element;
    }
}